import styled from 'styled-components';
import { Anchor } from '@bxp-framework/components';
import { colorContrastCSS } from '../../styles';
export const GenericShareButton = styled(Anchor) `
  background-color: ${({ buttonColor }) => buttonColor};
  border-radius: 0.3rem;
  color: ${({ buttonColor, colorOverride }) => colorOverride ? colorOverride : colorContrastCSS(buttonColor)};
  font-size: 1rem;
  ${({ block = false }) => block
    ? 'display: block;'
    : `
  display: inline-block;
  min-width: 150px;
  `}
  padding: 0.75rem;
  text-align: left;
  text-decoration: none;

  &:hover {
    color: ${({ buttonColor, colorOverride }) => colorOverride ? colorOverride : colorContrastCSS(buttonColor)};
  }
`;
export const InnerShareButton = styled.div `
  align-items: center;
  display: flex;
  justify-content: center;
  span {
    margin-left: 0.5rem;
  }
`;
//# sourceMappingURL=social-sharing.styles.js.map